import React, { Component } from "react";

export class CustomCaptcha extends Component {
  captchaRef = React.createRef();
  widgetId = null;

  componentDidMount() {
    // Expose callback for Google script
    window.onRecaptchaLoad = this.onLoadRecaptcha;

    if (!window.grecaptcha) {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } else {
      this.onLoadRecaptcha();
    }
  }

  componentWillUnmount() {
    if (this.widgetId !== null && window.grecaptcha) {
      window.grecaptcha.reset(this.widgetId);
    }
    delete window.onRecaptchaLoad;
  }

   onLoadRecaptcha = () => {
    if (this.captchaRef.current && window.grecaptcha) {
      this.widgetId = window.grecaptcha.render(
        this.captchaRef.current,
        {
          sitekey: this.props.Sitekey,
          callback: this.props.VerifyCallback,
        }
      );
    }
  };

  render() {
    return <div ref={this.captchaRef} />;
  }
}
